import "./SearchInput.scss";
interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  return (
    <div className="search_input_container">
      <svg
        className="search_input_icon"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path d="M6.33333 10.6667C5.12222 10.6667 4.09722 10.2472 3.25833 9.40833C2.41944 8.56944 2 7.54444 2 6.33333C2 5.12222 2.41944 4.09722 3.25833 3.25833C4.09722 2.41944 5.12222 2 6.33333 2C7.54444 2 8.56944 2.41944 9.40833 3.25833C10.2472 4.09722 10.6667 5.12222 10.6667 6.33333C10.6667 6.82222 10.5889 7.28333 10.4333 7.71667C10.2778 8.15 10.0667 8.53333 9.8 8.86667L13.5333 12.6C13.6556 12.7222 13.7167 12.8778 13.7167 13.0667C13.7167 13.2556 13.6556 13.4111 13.5333 13.5333C13.4111 13.6556 13.2556 13.7167 13.0667 13.7167C12.8778 13.7167 12.7222 13.6556 12.6 13.5333L8.86667 9.8C8.53333 10.0667 8.15 10.2778 7.71667 10.4333C7.28333 10.5889 6.82222 10.6667 6.33333 10.6667ZM6.33333 9.33333C7.16667 9.33333 7.875 9.04167 8.45833 8.45833C9.04167 7.875 9.33333 7.16667 9.33333 6.33333C9.33333 5.5 9.04167 4.79167 8.45833 4.20833C7.875 3.625 7.16667 3.33333 6.33333 3.33333C5.5 3.33333 4.79167 3.625 4.20833 4.20833C3.625 4.79167 3.33333 5.5 3.33333 6.33333C3.33333 7.16667 3.625 7.875 4.20833 8.45833C4.79167 9.04167 5.5 9.33333 6.33333 9.33333Z" />
      </svg>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="search_input"
      />
      {value && (
        <button
          onClick={() => onChange("")}
          className="search_input_clear"
          type="button"
          aria-label="Clear search"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path d="M8.0026 8.93334L9.93594 10.8667C10.0582 10.9889 10.2137 11.05 10.4026 11.05C10.5915 11.05 10.747 10.9889 10.8693 10.8667C10.9915 10.7445 11.0526 10.5889 11.0526 10.4C11.0526 10.2111 10.9915 10.0556 10.8693 9.93334L8.93594 8.00001L10.8693 6.06668C10.9915 5.94445 11.0526 5.7889 11.0526 5.60001C11.0526 5.41112 10.9915 5.25557 10.8693 5.13334C10.747 5.01112 10.5915 4.95001 10.4026 4.95001C10.2137 4.95001 10.0582 5.01112 9.93594 5.13334L8.0026 7.06668L6.06927 5.13334C5.94705 5.01112 5.79149 4.95001 5.6026 4.95001C5.41372 4.95001 5.25816 5.01112 5.13594 5.13334C5.01372 5.25557 4.9526 5.41112 4.9526 5.60001C4.9526 5.7889 5.01372 5.94445 5.13594 6.06668L7.06927 8.00001L5.13594 9.93334C5.01372 10.0556 4.9526 10.2111 4.9526 10.4C4.9526 10.5889 5.01372 10.7445 5.13594 10.8667C5.25816 10.9889 5.41372 11.05 5.6026 11.05C5.79149 11.05 5.94705 10.9889 6.06927 10.8667L8.0026 8.93334ZM8.0026 14.6667C7.08038 14.6667 6.21371 14.4917 5.4026 14.1417C4.59149 13.7917 3.88594 13.3167 3.28594 12.7167C2.68594 12.1167 2.21094 11.4111 1.86094 10.6C1.51094 9.7889 1.33594 8.92223 1.33594 8.00001C1.33594 7.07779 1.51094 6.21112 1.86094 5.40001C2.21094 4.5889 2.68594 3.88334 3.28594 3.28334C3.88594 2.68334 4.59149 2.20834 5.4026 1.85834C6.21371 1.50834 7.08038 1.33334 8.0026 1.33334C8.92483 1.33334 9.79149 1.50834 10.6026 1.85834C11.4137 2.20834 12.1193 2.68334 12.7193 3.28334C13.3193 3.88334 13.7943 4.5889 14.1443 5.40001C14.4943 6.21112 14.6693 7.07779 14.6693 8.00001C14.6693 8.92223 14.4943 9.7889 14.1443 10.6C13.7943 11.4111 13.3193 12.1167 12.7193 12.7167C12.1193 13.3167 11.4137 13.7917 10.6026 14.1417C9.79149 14.4917 8.92483 14.6667 8.0026 14.6667ZM8.0026 13.3333C9.49149 13.3333 10.7526 12.8167 11.7859 11.7833C12.8193 10.75 13.3359 9.4889 13.3359 8.00001C13.3359 6.51112 12.8193 5.25001 11.7859 4.21668C10.7526 3.18334 9.49149 2.66668 8.0026 2.66668C6.51371 2.66668 5.2526 3.18334 4.21927 4.21668C3.18594 5.25001 2.66927 6.51112 2.66927 8.00001C2.66927 9.4889 3.18594 10.75 4.21927 11.7833C5.2526 12.8167 6.51371 13.3333 8.0026 13.3333Z" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default SearchInput;
